module.exports = require("././dist/textAngular.js");
module.exports = require("././dist/textAngular-sanitize.js");
module.exports = require("././dist/textAngularSetup.js");
require("././dist/textAngular.css");


//////////////////
// WEBPACK FOOTER
// textAngular (bower component)
// module id = 1239
// module chunks = 0